import React, { useState } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import myImage01 from 'C:/Users/bswarnka/Pictures/pic04.jpg';
import gdImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/GenralDen.jpg';
import cdImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/CD.jpg';
import diImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/DI.jpg';
import ldImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/LD.jpg';
import odtImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Odt.jpg';
import onmsImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/OnmS.jpg';
import pdImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/PD.jpg';
import pdtImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Pdt.jpg';
import ptdtImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Ptdt.jpg';
import rctImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Rct.jpg';
import Button from '@mui/material/Button';
import './ScrollCardComp.css';

export default function ScrollCardComp() {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768, // 768px breakpoint for tablet devices
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480, // 480px breakpoint for mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };

  return (
    <div>
      <div className="row" style={{ margin: "20px 0" }}>
        <h2 className="text-dark">Our Services</h2>
        <div className="slider-container">
          <Slider {...settings}>
            <div className="col ml-3 mr-3">
              <div className="card">
                <img src={gdImage} className="card-img-top" alt="General Dentistry" />
                <div className="card-body">
                  <h5 className="card-title">General Dentistry</h5>
                  <p className="card-text">
                    Routine Check-ups & Cleaning: Regular dental check-ups and cleanings to prevent tooth decay, gum disease, and other oral health issues.
                  </p>
                </div>
              </div>
            </div>
            <div className="col ml-3 mr-3">
              <div className="card">
                <img src={cdImage} className="card-img-top" alt="Cosmetic Dentistry" />
                <div className="card-body">
                  <h5 className="card-title">Cosmetic Dentistry</h5>
                  <p className="card-text">
                    Teeth Whitening: Professional teeth whitening treatments to remove stains and brighten your smile.
                  </p>
                </div>
              </div>
            </div>
            <div className="col ml-3 mr-3">
              <div className="card">
                <img src={odtImage} className="card-img-top" alt="Orthodontics" />
                <div className="card-body">
                  <h5 className="card-title">Orthodontics</h5>
                  <p className="card-text">
                  Orthodontic treatments are designed to correct misaligned teeth and jaws, enhancing both function and esthetics. 
                  </p>
                </div>
              </div>
            </div>
            <div className="col ml-3 mr-3">
              <div className="card">
                <img src={pdtImage} className="card-img-top" alt="Periodontal Care" />
                <div className="card-body">
                  <h5 className="card-title">Periodontal Care</h5>
                  <p className="card-text">
                  At Aarogyam Dental Care, our periodontists are dedicated to diagnosing, treating, and preventing gum disease. 
                  </p>
                </div>
              </div>
            </div>
            <div className="col ml-3 mr-3">
              <div className="card">
                <img src={pdImage} className="card-img-top" alt="Pediatric Dentistry" />
                <div className="card-body">
                  <h5 className="card-title">Pediatric Dentistry</h5>
                  <p className="card-text">
                    Specialized care for children, focusing on preventive measures, oral hygiene education, and gentle treatments to ensure their dental health from a young age.
                  </p>
                </div>
              </div>
            </div>
            <div className="col ml-3 mr-3">
              <div className="card">
                <img src={rctImage} className="card-img-top" alt="Restorative Dentistry" />
                <div className="card-body">
                  <h5 className="card-title">Root Canal Treatment</h5>
                  <p className="card-text">
                      At Aarogyam, RCTs are performed with advanced techniques and modern equipment, making the procedure as comfortable and efficient as possible.

                  </p>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
}
  

// export default function ScrollCardComp() {
//     var settings = {
//         dots: true,
//         infinite: true,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         autoplay: true,
//         speed: 1000,
//         autoplaySpeed:5000,
//         cssEase:"linear",
//         responsive: [
//           {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 3,
//               infinite: true,
//               dots: true
//             }
//           },
//           {
//             breakpoint: 600,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 2,
//               initialSlide: 2
//             }
//           },
//           {
//             breakpoint: 480,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1
//             }
//           }
//         ]
//       };

//       return (
//         <div>
//         <div className="row" style={{margin:20}}>
//         <h2 class="text-dark">Our Services</h2>
//         <div className="slider-container">
//           <Slider {...settings}>
//             <div class="col ml-2">
//                 <div class="card h-150">
//                     <img src={gdImage} class="card-img-top" alt="..."/>
//                     <div class="card-body">
//                         <h5 class="card-title">General Dentistry</h5>
//                         <p class="card-text">Routine Check-ups & Cleaning: Regular dental check-ups and cleanings to prevent tooth decay, gum disease, and other oral health issues.</p>
//                     </div>
//                 </div>
//             </div>
//             <div class="col ml-2">
//                 <div class="card h-150">
//                     <img src={cdImage} class="card-img-top" alt="..."/>
//                     <div class="card-body">
//                         <h5 class="card-title">Cosmetic Dentistry</h5>
//                         <p class="card-text">Teeth Whitening: Professional teeth whitening treatments to remove stains and brighten your smile.</p>
//                     </div>
//                 </div>
//             </div>
//             <div class="col ml-2">
//                 <div class="card h-150">
//                     <img src={odtImage} class="card-img-top" alt="..."/>
//                     <div class="card-body">
//                         <h5 class="card-title">Orthodontics</h5>
//                         <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
//                     </div>
//                 </div>
//             </div>
//             <div class="col ml-2">
//                 <div class="card h-150">
//                     <img src={pdImage} class="card-img-top" alt="..."/>
//                     <div class="card-body">
//                         <h5 class="card-title">Periodontal Care</h5>
//                         <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
//                     </div>
//                 </div>
//             </div>
//             <div class="col ml-2">
//                 <div class="card h-150">
//                     <img src={pdtImage} class="card-img-top" alt="..."/>
//                     <div class="card-body">
//                         <h5 class="card-title">Pediatric Dentistry</h5>
//                         <p class="card-text">Specialized care for children, focusing on preventive measures, oral hygiene education, and gentle treatments to ensure their dental health from a young age.</p>
//                     </div>
//                 </div>
//             </div>
//             <div class="col ml-2">
//                 <div class="card h-150">
//                     <img src={rctImage} class="card-img-top" alt="..."/>
//                     <div class="card-body">
//                         <h5 class="card-title">Restorative Dentistry</h5>
//                         <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
//                     </div>
//                 </div>
//             </div>
//           </Slider>
//         </div>
//         </div>
//         </div>
//       );
//     }

const data = [
    {
        name: 'Ram',
        img :'./pic03.jpg',
        review: 'orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
    },
    {
        name: 'Sam',
        img : 'C:/Users/bswarnka/Pictures/pic04.jpg',
        review: 'orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
    },
    {
        name: 'Hari',
        img : 'C:/Users/bswarnka/Pictures/pic05.png',
        review: 'orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
    },
    {
        name: 'Amri',
        img : 'C:/Users/bswarnka/Pictures/pic04.jpg',
        review: 'orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
    },
    {
        name: 'Calc',
        img : "C:/Users/bswarnka/Pictures/pic03.jpg",
        review: 'orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
    },
    {
        name: 'Deb',
        img : 'C:/Users/bswarnka/Pictures/pic05.png',
        review: 'orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
    },

]